module.exports = __webpack_public_path__ + "static/media/amazon.96b5fc2e.png";